"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBAPP_MILOTIC = exports.ENTERPRISEAPP_GOTHITA = void 0;
exports.ENTERPRISEAPP_GOTHITA = 'enterpriseapp-gothita';
exports.WEBAPP_MILOTIC = 'webapp-milotic';
